import isNull from 'lodash/isNull';

class CookieAlert {
    COOKIE_NAME = 'cookie_alert';
    EXPIRY_DAYS = 365;
    VERSION = '0.1.3';

    constructor(options = {
        strings: {
            message: `We use cookies to make your interaction with our website easy and meaningful, to better understand your use of our website and to improve your experience on our website. By using this website you give your consent to us using cookies. To find out more about our use of cookies, click <a href="/CookiePolicy">here</a>.`,
            buttonText: 'I AGREE'
        },
        buttonAction: '#'
    }) {
        this.options = options;

        const status = this.getCookie(this.COOKIE_NAME);

        this.el = document.querySelector('#cookie-alert');

        if (isNull(status)) {
            this.render();
            this.bind();
        }
    }

    bind() {
        this.el.querySelector('.controls .btn').addEventListener('click', evt => {
            evt.preventDefault();
            this.setCookie(this.COOKIE_NAME, 'yes', this.EXPIRY_DAYS);

            this.el.parentNode.removeChild(this.el);
        });
    }

    render() {
        if (this.el === null) {
            const ctx = {
                message: this.options.strings.message,
                accept: {
                    term: this.options.strings.buttonText,
                    href: this.options.buttonAction
                }
            };
            const node = document.createElement('div');

            node.id = 'cookie-alert';

            const html = `<div class="wrap">
                <div class="content">${ctx.message}</div>
                <div class="controls"><a href="${ctx.accept.href}" class="btn btn-primary">${ctx.accept.term}</a></div>
            </div>`;

            node.innerHTML = html;

            document.body.appendChild(node);

            this.el = document.querySelector('#cookie-alert');
        }
    }

    get version() {
        return this.VERSION;
    }

    getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);

        return parts.length !== 2 ? null : parts.pop().split(';')
            .shift();
    }

    setCookie(name, value, expiryDays, domain, path) {
        const now = new Date();

        now.setDate(now.getDate() + (expiryDays || 365));

        const cookie = [
            `${name}=${value}`,
            `expires=${now.toUTCString()}`,
            `path=${(path || '/')}`
        ];

        if (domain) {
            cookie.push(`domain=${domain}`);
        }

        document.cookie = cookie.join(';');
    }
}

export default CookieAlert;
